import {ChangeDetectorRef, OnDestroy, Pipe, PipeTransform} from "@angular/core";
import {AppSettingsService} from "./app-settings.service";
import {Subscription} from "rxjs/Subscription";
import {KeyByObject} from "../misc/reduce-helpers";

@Pipe({
  name: "region",
  pure: false,
})
export class RegionPipe implements PipeTransform, OnDestroy {
  private subscription: Subscription;
  private regions: {[key: string]: string} = {};

  lastValue: string;
  lastResult: string;

  processResult(value: string, result: string): string {
    this.lastValue = value;
    this.lastResult = result;
    return result;
  }

  transform(value: string): string {
    if (value === undefined || value === null || value === "") return "";
    if (value === ".") return "";
    if (value === this.lastValue) return this.lastResult;

    const transformed = this.regions[value];

    if (transformed === undefined) {
      console.warn(`Could not find transformed value for "${value}"!`);
      return this.processResult(value, value);
    }

    return this.processResult(value, transformed);
  }

  ngOnDestroy() {
    if (this.subscription && !this.subscription.closed) {
      this.subscription.unsubscribe();
    }

    this.lastValue = undefined;
    this.lastResult = undefined;
    this.subscription = undefined;
  }

  constructor(
    private appSettingsService: AppSettingsService,
    private ref: ChangeDetectorRef,
  ) {
    this.subscription = this.appSettingsService.regions.subscribe((regionsArray) => {
      this.regions = (regionsArray || [])
        .reduce(
          (obj, region) => obj.add(region.id, `${region.code} - ${region.name}`),
          new KeyByObject(),
        )
        .toObject();

      this.lastValue = undefined;
      this.ref.markForCheck();
    });
  }
}
